import Swal from 'sweetalert2/dist/sweetalert2.js';
declare type TVueSwalInstance = typeof Swal & typeof Swal.fire;

// This class lets us have a factory to always return a single instance of $swal that can be imported anywhere
// This is needed to let us access $swal from non-vue locations like the API
class Factory implements InternalSwalFactory {
  init(swal: any) {
    this.innerSwal = swal;
  }
  private innerSwal: any = {};
  get $swal() {
    return this.innerSwal as TVueSwalInstance;
  }
}
export interface SwalFactory {
  $swal: TVueSwalInstance;
}
export interface InternalSwalFactory extends SwalFactory {
  init(swal: any): void;
}

const swal = new Factory();
export default swal as SwalFactory;